export default __webpack_public_path__ + "static/media/homes_for_our_troops.d0397ee5.png";